import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class LeaveBalanceDetailsDto implements ILeaveBalanceDetailsDto {
    employee!: EmployeeSummaryDto;
    empLegalName!: string | undefined;
    calenderYear!: string | undefined;
    fromMonth!: Date | undefined;
    toMonth!: Date | undefined;
    leaveTypeId!: number;
    leaveName!: string | undefined;
    openLeave!: number;
    earnLeave!: number;
    enjoyLeave!: number;
    encashLeave!: number;
    lapseLeave!: number;
    balanceLeave!: number;

    constructor(data?: ILeaveBalanceDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
            this.calenderYear = _data["calenderYear"];
            this.fromMonth = _data["fromMonth"] ? new Date(_data["fromMonth"].toString()) : <any>undefined;
            this.toMonth = _data["toMonth"] ? new Date(_data["toMonth"].toString()) : <any>undefined;
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveName = _data["leaveName"];
            this.openLeave = _data["openLeave"];
            this.earnLeave = _data["earnLeave"];
            this.enjoyLeave = _data["enjoyLeave"];
            this.encashLeave = _data["encashLeave"];
            this.lapseLeave = _data["lapseLeave"];
            this.balanceLeave = _data["balanceLeave"];
        }
    }

    static fromJS(data: any): LeaveBalanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveBalanceDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        data["calenderYear"] = this.calenderYear;
        data["fromMonth"] = this.fromMonth ? this.fromMonth.toISOString() : <any>undefined;
        data["toMonth"] = this.toMonth ? this.toMonth.toISOString() : <any>undefined;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveName"] = this.leaveName;
        data["openLeave"] = this.openLeave;
        data["earnLeave"] = this.earnLeave;
        data["enjoyLeave"] = this.enjoyLeave;
        data["encashLeave"] = this.encashLeave;
        data["lapseLeave"] = this.lapseLeave;
        data["balanceLeave"] = this.balanceLeave;
        return data; 
    }
}

export interface ILeaveBalanceDetailsDto {
    employee: EmployeeSummaryDto;
    empLegalName: string | undefined;
    calenderYear: string | undefined;
    fromMonth: Date | undefined;
    toMonth: Date | undefined;
    leaveTypeId: number;
    leaveName: string | undefined;
    openLeave: number;
    earnLeave: number;
    enjoyLeave: number;
    encashLeave: number;
    lapseLeave: number;
    balanceLeave: number;
}

